import { boolean, object, string, TypeOf } from 'zod';

import { ProductMediaTrailer } from './trailer';

/* --------------------------- BrightcoveRequestData ----------------------- */

const BrightcoveRequestData = object({
    url: string(),
    jwt: string().optional(),
    policyId: string().optional(),
});

export type BrightcoveRequestData = TypeOf<typeof BrightcoveRequestData>;

/* --------------------------- ProductMediaFeature -------------------------- */

export const ProductMediaFeature = ProductMediaTrailer.extend({
    entitlementId: string().optional(),
    legacyEncoding: boolean().optional(),
    preAuthId: string().optional(),
    brightcove: BrightcoveRequestData.optional(),
    /** Not from the API. Present only when internally converted from a Brightcove API response */
    brightcoveVideoId: string().optional(),
});

export type ProductMediaFeature = TypeOf<typeof ProductMediaFeature>;
